import React from "react";

const CityDropdown = ({ cities, selectedCity, onChange }) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium mb-1">City:</label>
      <select className="w-full p-2 border rounded" value={selectedCity} onChange={onChange}>
        <option value="">All Cities</option>
        {cities.map((city) => (
          <option key={city} value={city}>{city}</option>
        ))}
      </select>
    </div>
  );
};

export default CityDropdown;
